import Dexie from "dexie";

export const db = new Dexie("dexieConnectionsDb");

export const TABLES = {
    SCREENSHOTS: "screenshots",
};

function init() {
    db.version(1).stores({
        [TABLES.SCREENSHOTS]: "id, source",
    });
}

init();
